import { useCallback, useEffect, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { ProjectPlanSelectRow } from '../model'

type UseProjectPlanSelectDataProps = {
  snapshotUuid: string
}

export const useProjectPlanSelectData = ({
  snapshotUuid,
}: UseProjectPlanSelectDataProps) => {
  const [rows, setRows] = useState<ProjectPlanSelectRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const { fetchMasterSchedule } = useProjectPlanSnapshotRepository()

  const fetchSnapshotData = useCallback(
    async (uuid: string) => {
      const response = await fetchMasterSchedule(uuid)
      return response.map(resp => ({
        uuid: resp.uuid,
        treeValue: resp.path,
        displayName: resp.wbsItem.displayName,
        type: resp.type,
      }))
    },
    [fetchMasterSchedule]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)
        const result = await fetchSnapshotData(snapshotUuid)
        setRows(result)
      } catch (error) {
        console.error('Failed to fetch project plan data:', error)
        setRows([])
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [snapshotUuid, fetchSnapshotData])

  return { rows, isLoading }
}
